import { hot } from 'react-hot-loader/root';

import React, { Component, Fragment } from 'react';
import { Switch, Redirect } from 'react-router';

import Helmet from 'react-helmet';

import Route from 'app/components/routes/Route';

import NotFound from 'app/pages/errors/NotFound';
import routes from 'app/pages/routes';

import { isNull } from 'app/utils/validators';

import ogImage from 'assets/images/og_image.png';
import logo180 from 'assets/images/logo_180.png';

import favicon from 'assets/favicon/favicon.ico';
import favicon16 from 'assets/favicon/favicon-16x16.png';
import favicon32 from 'assets/favicon/favicon-32x32.png';
import appleLogo180 from 'assets/favicon/apple-icon-180x180.png';

import './style.scss';

const { DOMAIN, FACEBOOK_APP_ID } = process.env;

const BLOOM_IMAGE = {
  key: 'efacf33b-4afb-4b30-a5ec-7e65b21cd2f2',
  attachmentFormat: 'image',
  attachment: {
    content_type: 'image/png',
    height: 630,
    originalFilename: 'Untitled.png',
    url: 'https://efinder-cdn.eineblu.me/chatie/chatie_story_cover_images/public-6d15d809-4080-481c-9552-342956c560a5.png',
    width: 1200,
  },
  attachmentType: 'ChatieStoryCoverImage',
};

class AppContainer extends Component {
  render() {
    const siteName = '채티 블룸';
    const title = `${siteName} - 톡톡 탭하며 읽는 새로운 웹소설`;
    const description =
      '채팅형 소설 창작 플랫폼, 채티 블룸! 당신의 이야기를 작품으로 만들어보세요';
    const keywords =
      '채티블룸, 블룸, bloom, 로맨스, 판타지, 스릴러, 비엘, BL, 성인, 19, 로맨스판타지, 로판, 웹소설, webnovel';

    const ogImageUrl = ogImage.startsWith('/')
      ? `${DOMAIN}${ogImage}`
      : ogImage;

    return (
      <Fragment>
        <Helmet>
          <meta name="theme-color" content="#fff" />
          <meta name="application-name" content={siteName} />

          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />

          <meta property="og:url" content={DOMAIN} data-react-helmet="true" />
          <meta
            property="og:site_name"
            content={siteName}
            data-react-helmet="true"
          />
          <meta property="og:title" content={title} data-react-helmet="true" />
          <meta
            property="og:description"
            content={description}
            data-react-helmet="true"
          />
          <meta
            property="og:image"
            content={BLOOM_IMAGE.attachment.url}
            data-react-helmet="true"
          />
          <meta
            property="og:image:width"
            content="1200"
            data-react-helmet="true"
          />
          <meta
            property="og:image:height"
            content="630"
            data-react-helmet="true"
          />
          <meta property="og:locale" content="ko_KR" />

          {!isNull(FACEBOOK_APP_ID) && (
            <meta property="fb:app_id" content={FACEBOOK_APP_ID} />
          )}
          <meta
            name="google-site-verification"
            content="24eIVkGjc9sC-Xvk9dWrqXsOmNTiQLqHoSnAF9gK9V4"
          />
          <meta
            name="naver-site-verification"
            content="7cf616aaacb5631e522efd60039bbc21f121bd6a"
          />
          <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
          <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
          <link rel="shortcut icon" type="image/x-icon" href={favicon} />
          <link rel="shortcut icon" href={appleLogo180} />
          <link rel="apple-touch-icon" href={appleLogo180} />
          <title data-react-helmet="true">{title}</title>
        </Helmet>
        <Switch>
          <Redirect
            from="/coin-recharge"
            to={{
              pathname: '/payment',
              state: { from_: 'outside' },
            }}
          />
          <Redirect from="/coin-histories" to="/payment-histories?type=coin" />

          {routes.map((route) => {
            if (route.auth) {
              return (
                <route.auth key={`route-${route.name}`} {...route} exact />
              );
            }

            return <Route key={`route-${route.name}`} {...route} exact />;
          })}
          <Route component={NotFound} />
        </Switch>
      </Fragment>
    );
  }
}

export default hot(AppContainer);
export { AppContainer };



// WEBPACK FOOTER //
// ./src/app/containers/AppContainer/index.jsx